const PREFIX = 'PREF_';

const preferenceConstants = {
  SET_PREFERENCE: PREFIX + 'SET_PREFERENCE',
};

export default preferenceConstants;
